import errorManager from '@/rollbar.js';

const initLestener = (select_selector, button_selector) => {
  $(button_selector).click(function (event) {
    event.preventDefault();
    let visible = null;
    let filteredValues = [];
    let select2Holder = $(select_selector).data();

    if (select2Holder && select2Holder.select2) {
      let results = select2Holder.select2.$results;
      if (results) {
        if ($(results[0]) && $(results[0]).children().length > 0) {
          $(results[0])
            .children()
            .each(function (index, node) {
              let selectedValue;
              let id = $(node).attr('id');
              let arr = id.split('-');
              if (arr && arr.length > 0) {
                selectedValue = arr[arr.length - 1];
                filteredValues.push(selectedValue);
              }

              $(node).trigger('mouseup');
            });
        }
      }
    }
  });
};

const init = () => {
  try {
    initLestener();
  } catch (e) {
    errorManager(e);
  }
};

window.Select2SelectAll = {
  init: init,
};
